import { createSlice } from '@reduxjs/toolkit'

export const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    refresh: false,
    orderList: [],
    allOrders: [], // Store all orders without filtering
    order: [],
    itemList: [],

    // sort
    sortList: {
      code: { isCrescent: false, isDecrescent: false, isNumeric: true },
      date: { isCrescent: false, isDecrescent: false, isDate: true },
      value: { isCrescent: false, isDecrescent: false, isFloat: true }
    },

    page: 0,
    itemTotalItems: 0, // Total de todos os pedidos
    filteredTotalItems: 0, // Total de pedidos após filtro

    showAll: (() => {
      // Load preference from localStorage on initialization
      const savedPreference = localStorage.getItem('@barrosShowAll')
      return savedPreference ? JSON.parse(savedPreference) : false
    })(),
  },
  reducers: {
    setShowAll: (state, action) => {
      state.showAll = action.payload
      
      // Save preference to localStorage
      localStorage.setItem('@barrosShowAll', JSON.stringify(action.payload))
      
      // Filter orders based on showAll state
      if (action.payload) {
        // Show all orders
        state.orderList = state.allOrders
        state.filteredTotalItems = state.itemTotalItems
      } else {
        // Show only orders with dFases === 'Orçamento'
        const filteredOrders = state.allOrders.filter(order => order.dFases === 'Orçamento')
        state.orderList = filteredOrders
        state.filteredTotalItems = filteredOrders.length
      }
      // Reset page when toggling filter
      state.page = 0
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload
    },
    setOrderList: (state, action) => {
      // Store all orders in allOrders
      state.allOrders = action.payload
      // Apply filtering based on showAll state
      if (state.showAll) {
        state.orderList = action.payload
        state.filteredTotalItems = state.itemTotalItems
      } else {
        const filteredOrders = action.payload.filter(order => order.dFases === 'Orçamento')
        state.orderList = filteredOrders
        state.filteredTotalItems = filteredOrders.length
      }
    },
    setOrder: (state, action) => {
      state.order = action.payload
    },
    setItemList: (state, action) => {
      state.itemList = action.payload
    },
    setPage: (state, action) => {
      state.page = action.payload
    },
    setOrderTotalItems: (state, action) => {
      state.itemTotalItems = action.payload
    },
    sortList: (state, action) => {
      let { sortCheckerName, fieldToSort } = action.payload
      const { isCrescent, isDecrescent, isNumeric, isFloat, isDate } =
        state.sortList[sortCheckerName]

      if (isDecrescent) {
        state.sortList[sortCheckerName].isDecrescent = false
        // Reapply filtering after resetting sort
        if (state.showAll) {
          state.orderList = [...state.allOrders]
          state.filteredTotalItems = state.itemTotalItems
        } else {
          const filteredOrders = state.allOrders.filter(order => order.dFases === 'Orçamento')
          state.orderList = filteredOrders
          state.filteredTotalItems = filteredOrders.length
        }
        return
      }

      // Sort the current filtered list
      const sortedList = [...state.orderList].sort((a, b) => {
        if (isNumeric) {
          return isCrescent
            ? Number(a[fieldToSort]) - Number(b[fieldToSort])
            : Number(b[fieldToSort]) - Number(a[fieldToSort])
        }

        if (isFloat) {
          return isCrescent
            ? parseFloat(a[fieldToSort]) - parseFloat(b[fieldToSort])
            : parseFloat(b[fieldToSort]) - parseFloat(a[fieldToSort])
        }

        if (isDate) {
          return isCrescent
            ? new Date(a[fieldToSort]) - new Date(b[fieldToSort])
            : new Date(b[fieldToSort]) - new Date(a[fieldToSort])
        }

        return 0
      })
      state.orderList = sortedList

      if (!isCrescent && !isDecrescent) {
        state.sortList[sortCheckerName].isCrescent = true
        return
      }

      if (isCrescent) {
        state.sortList[sortCheckerName].isCrescent = false
        state.sortList[sortCheckerName].isDecrescent = true
      }
     }
  }
})

export const {
  setShowAll,
  setRefresh,
  setOrderList,
  setOrder,
  setItemList,
  setPage,
  setOrderTotalItems,
  sortList
} = orderSlice.actions

export default orderSlice.reducer
